import { defineMessages } from "react-intl";
export default defineMessages({
    seoTitle: {
        id: "app.restricted.seoTitle",
        defaultMessage: "Restricted access",
    },
    seoDescription: {
        id: "app.restricted.seoDescription",
        defaultMessage: "You don't have access to this community.",
    },
    title: {
        id: "app.restricted.title",
        defaultMessage: "This link is restricted",
    },
    description: {
        id: "app.restricted.description",
        defaultMessage: "You don't have access to this community. Contact your organization admin if you need access to its reports.",
    },
    backToPortfolio: {
        id: "app.restricted.backToPortfolio",
        defaultMessage: "Back to Portfolio",
    },
    backToAdminDashboard: {
        id: "app.restricted.backToAdminDashboard",
        defaultMessage: "Back to Admin Dashboard",
    },
});
